import {Component, OnInit, ViewChild} from '@angular/core';
import {RicambiService} from '../service/ricambi.service';
import {Categoria} from '../models/categoria';
import {Accessorio} from '../models/accessorio';
import {TipoAccessorio} from '../models/tipoaccessorio';
import {Carrello} from '../models/carrello';
import {TwsCategoriaComponent} from '../tws-categoria/tws-categoria.component';
import {MatSnackBar} from '@angular/material';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {Location} from '@angular/common';
import 'rxjs/add/operator/switchMap';
import {UserService} from '../service/user.service';


@Component({
    selector: 'app-tws-accessori',
    templateUrl: './tws-accessori.component.html',
    styleUrls: ['./tws-accessori.component.css']
})
export class TwsAccessoriComponent implements OnInit {

    @ViewChild(TwsCategoriaComponent) private categorieComponent: TwsCategoriaComponent;
    categorie: Array<Categoria> = new Array<Categoria>();//in teoria ho l'albero e posso metterlo in cache
    accessoriTrovati: Array<Accessorio>;//da ricerca
    tipiTrovati: Array<TipoAccessorio>;//da ricerca
    categoriaCorrente: Categoria = new Categoria(0, "", "", 0);
    codice: string;
    descrizione: string;
    lastCategoria: any;
    lastAzione: any;
    ricerca: boolean = false;
    catAccessorioSelezionato: TipoAccessorio;
    comp: any;

    mostraLista: boolean = false;
    mostraMacchine: boolean = false;
    mostraTipi: boolean = false;
    mostraComp: boolean = false;
    caricamento: boolean = true;

    constructor(private ricambiService: RicambiService,
        private route: ActivatedRoute, private location: Location, private router: Router, private userService: UserService, public snackBar: MatSnackBar) {

    }
    ngDoCheck() {
        let idCategoria = +this.route.snapshot.params['id'];
        let azione = this.route.snapshot.data[0]['azione'];

        if (idCategoria) {
            if (idCategoria != this.lastCategoria) {
                this.lastCategoria = idCategoria;
                if (azione) {
                    this.lastAzione = azione;
                }
                this.ngOnInit();
            } else {
                if (azione && azione != this.lastAzione) {
                    this.lastAzione = azione;
                    this.ngOnInit();
                }
            }
        }

    }

    //azione:comp e lista
    //tutte e due prendono il tipo categoria accessorio
    ngOnInit() {
        this.caricamento = true;
        this.catAccessorioSelezionato = undefined;
        this.ricambiService.getCategorie().then(heroes => {this.categorie = heroes; this.caricamento = false;});
        this.accessoriTrovati = new Array<Accessorio>();//da ricerca
        this.categoriaCorrente = new Categoria(0, "", "", 0);
        this.mostraMacchine = true;
        this.ricerca = false;
        let azione = this.route.snapshot.data[0]['azione'];
        let idCategoria = +this.route.snapshot.params['id'];
        this.lastAzione = azione;
        if (idCategoria) {
            this.lastCategoria = idCategoria;
            this.ricambiService.getCategorie().then(heroes => {
                let categoria: Categoria[] = heroes.filter(categoria => categoria.id == idCategoria);

                if (azione) {
                    let idTipo = +this.route.snapshot.params['categoria'];
                    this.resetRouteCategoria(categoria[0]);
                    this.ricambiService.getTipoAccessori(this.categoriaCorrente).then(heroes => {
                        let tipoAcc: TipoAccessorio[] = heroes.filter(categoria => categoria.id == idTipo);
                        this.catAccessorioSelezionato = tipoAcc[0];
                        if (azione == "comp") {
                            this.caricaCompatibilita(this.catAccessorioSelezionato);
                        }
                        if (azione == "lista") {
                            this.caricalista(this.catAccessorioSelezionato);
                        }
                    });
                } else {
                    this.onRouteCategoria(categoria[0]);
                }
            });
        }

    }

    reset(): void {
        this.catAccessorioSelezionato = undefined;
        this.accessoriTrovati = new Array<Accessorio>();//da ricerca
        this.categoriaCorrente = new Categoria(0, "", "", 0);
        this.tipiTrovati = new Array<TipoAccessorio>();
        this.mostraMacchine = true;
        this.mostraTipi = false;
        this.mostraLista = false;
        this.mostraComp = false;
        this.toggle = false;
        if (this.categorieComponent) {
            this.categorieComponent.categoria = this.categoriaCorrente;
        }
    }

    onSelectCategoria(hero: Categoria): void {
        this.router.navigate(['/accessori', hero.id]);
    }
    resetRouteCategoria(hero: Categoria): void {
        this.caricamento = false;
        this.mostraMacchine = false;
        this.mostraTipi = false;
        this.mostraLista = false;
        this.mostraComp = false;
        this.categoriaCorrente = hero;
        if (this.categorieComponent) {
            this.categorieComponent.categoria = this.categoriaCorrente;
        }
        this.ricerca = false;
        this.codice = "";
        this.descrizione = "";
        this.catAccessorioSelezionato = undefined;
        this.toggle = false;

    }

    onRouteCategoria(hero: Categoria): void {
        this.resetRouteCategoria(hero);
        if (this.categoriaCorrente.padre) {
            this.mostraMacchine = false;
            this.mostraTipi = true;
            this.mostraLista = false;
            this.mostraComp = false;
        } else {
            this.mostraMacchine = true;
            this.mostraTipi = false;
            this.mostraLista = false;
            this.mostraComp = false;
        }
        this.ricambiService.getTipoAccessori(this.categoriaCorrente).then(mac => {
            this.tipiTrovati = mac;
            if(this.tipiTrovati && this.tipiTrovati.length>0){
                this.mostraMacchine = false;
                this.mostraTipi = true;
            }
        });

        this.caricamento = false;

    }
    get navigazione(): Array<Categoria> {
        if (this.categorieComponent) {
            return this.categorieComponent.navigazione;
        } else {
            return new Array<Categoria>();
        }
    }


    cercaAccessori(): void {

        this.ricerca = true;
        this.ricambiService.cercaAccessori(this.codice, this.descrizione, 0, 0).then(mac => this.risultatiRicerca(mac));
    }

    risultatiRicerca(mac: Accessorio[]): void {
        this.caricamento = false;
        this.accessoriTrovati = mac
        this.mostraMacchine = false;
        this.mostraTipi = false;
        this.mostraLista = true;
        this.mostraComp = false;
        this.toggle = false;
    }
    aggiungiCarrello(ricambio: Accessorio): void {
        let qta = 1;
        if (ricambio.qta && ricambio.qta > 1) {
            qta = ricambio.qta;
        }
        this.ricambiService.aggiungiCarrello(ricambio.id, qta).then(carrello => this.aggiunto(carrello));

    }

    aggiunto(carrello: Carrello) {
        this.snackBar.open(RicambiService.traduci("Prodotto aggiunto al carrello"), "", {duration: 2000});
    }

    caricaCompatibilita(sel: TipoAccessorio): void {
        this.catAccessorioSelezionato = sel;
        this.ricambiService.cercaCompatibilita(this.categoriaCorrente, sel.id).then(mac => this.risultatoContabilita(mac));
    }

    compatibilita(sel: TipoAccessorio): void {
        //this.catAccessorioSelezionato = sel;
        this.router.navigate(['/accessori', this.categoriaCorrente.id, "comp", sel.id]);
        //    this.ricambiService.cercaCompatibilita(this.categoriaCorrente, sel.id).then(mac => this.risultatoContabilita(mac));
    }
    lista(sel: TipoAccessorio): void {
        //this.catAccessorioSelezionato = sel;
        this.router.navigate(['/accessori', this.categoriaCorrente.id, "lista", sel.id]);
    }


    caricalista(sel: TipoAccessorio): void {
        this.catAccessorioSelezionato = sel;
        this.ricambiService.cercaAccessori(this.codice, this.descrizione, sel.id, this.categoriaCorrente.id).then(mac => this.risultatiRicerca(mac));
        this.mostraMacchine = false;
        this.mostraTipi = false;
        this.mostraLista = true;
        this.mostraComp = false;
        this.ricerca = false;
    }

    risultatoContabilita(mac: any): void {
        this.caricamento = false;
        this.mostraMacchine = false;
        this.mostraTipi = false;
        this.mostraLista = false;
        this.mostraComp = true;
        this.comp = mac
        this.ricerca = false;
    }

    get utente(): any {
        return this.userService.getProfilo();
    }

    vediTuttiAccessori(sel: TipoAccessorio): void {
        this.ricambiService.cercaAccessori(this.codice, this.descrizione, sel.id, 0).then(mac => this.risultatiRicerca(mac));
        this.mostraMacchine = false;
        this.mostraTipi = false;
        this.mostraLista = true;
        this.mostraComp = false;
        this.ricerca = false;
    }
    vediAccessori(sel: TipoAccessorio): void {
        this.caricalista(sel);
    }

    toggle: boolean = false;
    clickToggle(): void {
        this.toggle = !this.toggle;
    }


}



// WEBPACK FOOTER //
// ./src/app/tws-accessori/tws-accessori.component.ts